import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import defaultFormImg from 'assets/icons/form-builder/templates/default.svg';
import stepperFormImg from 'assets/icons/form-builder/templates/stepper.svg';
import useAuth from 'hooks/useAuth';
import useFormBuilderTemplate from 'hooks/useFormBuilderTemplate';
import useUser from 'hooks/useUser';
import { useModal } from 'mui-modal-provider';
import { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { store } from 'store';
import { SET_CREATE_FORM_FIELDS, SET_ITEMS, SET_LNG, SET_STEPS } from 'store/actions';
import { DefaultRootStateProps } from 'types';
import { User } from 'types/user';
import DialogClose from '../buttons/DialogClose';
// import FormLocales from '../form-builder/FormLocales';
import FormContainer from '../inputs/FormContainer';
import FormTitle from './FormTitle';
export const roleToRoleEnum = new Map([
  ['PROVIDER', 'provider'],
  ['PROVIDER_ADMINISTRATOR (S)', 'providerAdministratorS'],
  ['PROVIDER_ADMINISTRATOR (D)', 'providerAdministratorD'],
  ['ADMINISTRATOR', 'administrator']
]);
const CreateForm = ({ onClose, onCancel, open, isFromTemplate, isClinicDocuments, documentId, targetAudience }: any) => {
  const formBuilder = useSelector((state: DefaultRootStateProps) => state.formBuilder);
  const globalLanguage = useSelector((state: DefaultRootStateProps) => state.customization);
  const { userId } = useAuth();
  const { user } = useUser(userId);
  const { templates } = useFormBuilderTemplate({ userId });
  console.log('Templates are ', templates);
  const intl = useIntl();
  let formData = {};
  const [formType, setFormType] = useState<any>(formBuilder?.type ?? '');
  const [name, setName] = useState(formBuilder?.name ?? '');
  const [nameFrench, setNameFrench] = useState(formBuilder?.nameFrench ?? '');
  const [description, setDescription] = useState(formBuilder?.description ?? '');
  const [descriptionFrench, setDescriptionFrench] = useState(formBuilder?.descriptionFrench ?? '');
  const [templateAvailableTo, setTemplateAvailableTo] = useState<any>({
    provider: formBuilder?.templateAvailableTo?.provider ?? false,
    providerAdministratorS: formBuilder?.templateAvailableTo?.providerAdministratorS ?? false,
    providerAdministratorD: formBuilder?.templateAvailableTo?.providerAdministratorD ?? false,
    administrator: formBuilder?.templateAvailableTo?.administrator ?? false
  });
  console.log(formBuilder?.lng, 'lang');
  const [lng, setLng] = useState(formBuilder?.lng ?? [globalLanguage.locale]);
  const [isForNotes, setIsForNotes] = useState(formBuilder?.isForNotes ?? false);
  const [formError, setFormError] = useState({ lngError: '', nameError: '', nameFrenchError: '', formTypeError: '' });
  // const [lngError, setLngError] = useState('');
  // const [nameError, setNameError] = useState('');
  // const [formTypeError, setFormTypError] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState<any>(formBuilder?.template ?? '');

  const handleSuccess = (e: any) => {
    console.log('handleSuccess', e);
    if (!lng || !formType || !name) {
      return setFormError((prev) => ({
        ...prev,
        lngError: !lng?.length ? ((<FormattedMessage defaultMessage="Please select a language" />) as unknown as string) : '',
        formTypeError: !formType ? ((<FormattedMessage defaultMessage="Please select a form type" />) as unknown as string) : '',
        nameError: !name ? ((<FormattedMessage defaultMessage="Please enter a title" />) as unknown as string) : '',
        nameFrenchError:
          lng?.includes('fr') && !nameFrench
            ? ((<FormattedMessage defaultMessage="Please enter a title in french" />) as unknown as string)
            : ''
      }));
    } else {
      setFormError((prev) => ({
        lngError: '',
        nameError: '',
        nameFrenchError: '',
        formTypeError: ''
      }));
    }
    formData = {
      template: selectedTemplate,
      type: formType,
      templateAvailableTo,
      lng,
      name,
      nameFrench,
      description,
      descriptionFrench,
      defaultStepName: formBuilder?.defaultStepName,
      defaultStepNameFrench: formBuilder?.defaultStepNameFrench,
      isForNotes,
      isClinicDocuments: isClinicDocuments,
      documentId
    };
    console.log(formData, 'FD', 'handle success');
    handleAdd(formData);
  };
  const { showModal } = useModal();
  const [openFormTitle, setOpenFormTitle] = useState(false);
  const handleAdd = useCallback(
    (formData) => {
      store.dispatch({ type: SET_CREATE_FORM_FIELDS, payload: formData });
      // Set Template Data
      if (formData.template && (!formBuilder.name || !formBuilder?.nameFrench)) {
        console.log(formData.template, templates);
        const selectedTemplateData = templates?.find((template) => template._id === formData.template);
        console.log(selectedTemplateData, 'selectedTemplateData');
        if (selectedTemplateData) {
          const updatedSteps = selectedTemplateData?.steps ?? [];
          if (updatedSteps.length > 0) {
            updatedSteps[0] = {
              title: selectedTemplateData?.steps[0]?.title ?? '',
              titleFrench: selectedTemplateData?.steps[0]?.titleFrench ?? '',
              items: selectedTemplateData?.items ?? []
            };
          }
          store.dispatch({ type: SET_ITEMS, payload: selectedTemplateData?.items ?? [] });
          store.dispatch({
            type: SET_STEPS,
            payload: updatedSteps && updatedSteps.length ? updatedSteps : [{ title: selectedTemplateData?.name ?? '', items: [] }]
          });
        }
      }
      console.log(formBuilder, 'FBB');
      const modal = showModal(FormTitle, {
        onClose: () => {
          modal.hide();
          setOpenFormTitle(false);
        },
        onCancel: () => {
          modal.hide();
          setOpenFormTitle(false);
        },
        open: openFormTitle,
        isFromTemplate,
        isEditing: formBuilder?.name,
        isClinicDocuments,
        documentId,
        targetAudience
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [showModal, templates]
  );
  useEffect(() => {
    if (globalLanguage && !formBuilder.lng) {
      store.dispatch({ type: SET_LNG, payload: globalLanguage.locale });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    // <FormLocales>
    <Dialog maxWidth="sm" fullWidth sx={{ '& .MuiDialog-paper': { p: 0 } }} onClose={onClose} open={open}>
      <FormContainer onSuccess={handleSuccess}>
        <DialogTitle sx={{ color: '#1D1D1D' }}>
          {isFromTemplate ? (
            formBuilder?.name !== '' ? (
              <FormattedMessage defaultMessage="Edit Template" />
            ) : (
              <FormattedMessage defaultMessage="Create New Template" />
            )
          ) : formBuilder?.name !== '' ? (
            <FormattedMessage defaultMessage="Edit Form" />
          ) : (
            <FormattedMessage defaultMessage="Create New Form" />
          )}
          <DialogClose onClose={onClose} />
        </DialogTitle>
        <Typography px={3} sx={{ color: '#727272' }}>
          <FormattedMessage
            defaultMessage="
          Please fill/select all the information properly"
          />
        </Typography>
        <DialogContent sx={{ p: 3 }}>
          <Grid container direction="column" gap={1}>
            <Grid item>
              <Grid container direction="column">
                <Grid container direction="column">
                  <Grid item>
                    <FormLabel required sx={{ color: '#565656', fontWeight: 800 }}>
                      <FormattedMessage defaultMessage="Form Language" />
                    </FormLabel>
                  </Grid>
                  <Grid item>
                    <FormControlLabel
                      control={<Checkbox />}
                      label={<FormattedMessage defaultMessage="English" />}
                      checked={lng?.includes('en')}
                      onClick={() =>
                        setLng(
                          (prev) =>
                            prev.includes('en')
                              ? prev.filter((item) => item !== 'en') // Remove 'en' if already checked
                              : [...prev, 'en'] // Add 'en' if not checked
                        )
                      }
                    />

                    <FormControlLabel
                      control={<Checkbox />}
                      label={<FormattedMessage defaultMessage="French" />}
                      checked={lng?.includes('fr')}
                      onClick={() =>
                        setLng(
                          (prev) =>
                            prev.includes('fr')
                              ? prev.filter((item) => item !== 'fr') // Remove 'en' if already checked
                              : [...prev, 'fr'] // Add 'en' if not checked
                        )
                      }
                    />
                  </Grid>
                </Grid>
                {formError.lngError ? <Typography color="red">{formError.lngError}</Typography> : null}
              </Grid>
            </Grid>
            <Grid item>
              {isFromTemplate && (
                <Grid container direction="column">
                  <Grid item>
                    <Typography sx={{ color: '#565656', fontWeight: 800 }}>
                      <FormattedMessage defaultMessage="Template Available to" />
                    </Typography>
                  </Grid>
                  <Grid item>
                    <FormControlLabel
                      control={<Checkbox />}
                      label={<FormattedMessage defaultMessage="Provider" />}
                      checked={templateAvailableTo?.provider}
                      onClick={() => setTemplateAvailableTo((prev) => ({ ...prev, provider: !prev?.provider }))}
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label={<FormattedMessage defaultMessage="Provider Adminstrator (S)" />}
                      checked={templateAvailableTo?.providerAdministratorS}
                      onClick={() => setTemplateAvailableTo((prev) => ({ ...prev, providerAdministratorS: !prev?.providerAdministratorS }))}
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label={<FormattedMessage defaultMessage="Provider Adminstrator (D)" />}
                      checked={templateAvailableTo?.providerAdministratorD}
                      onClick={() => setTemplateAvailableTo((prev) => ({ ...prev, providerAdministratorD: !prev?.providerAdministratorD }))}
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label={<FormattedMessage defaultMessage="Administrator" />}
                      checked={templateAvailableTo?.administrator}
                      onClick={() => setTemplateAvailableTo((prev) => ({ ...prev, administrator: !prev?.administrator }))}
                    />
                  </Grid>
                </Grid>
              )}
              <Grid item mb={1}>
                <Grid container direction="column" gap={1}>
                  <Grid item>
                    <FormLabel required sx={{ color: '#565656', fontWeight: 800 }}>
                      <FormattedMessage defaultMessage="Title" />
                    </FormLabel>
                  </Grid>
                  <Grid item mb={1}>
                    <TextField
                      name="name"
                      placeholder={intl.formatMessage({ defaultMessage: 'Enter title' })}
                      value={name}
                      required
                      onChange={(e) => {
                        if (e.target.value !== '') {
                          // setNameError('');
                          setFormError((prev) => ({
                            ...prev,
                            nameError: ''
                          }));
                        }
                        setName(e.target.value);
                      }}
                      fullWidth
                    />
                  </Grid>
                </Grid>
                {formError.nameError ? <Typography color="red">{formError.nameError}</Typography> : null}
              </Grid>
              <Grid item gap={1} mb={1}>
                <Grid container direction="column" gap={1}>
                  <Grid item>
                    <FormLabel sx={{ color: '#565656', fontWeight: 800 }}>
                      <FormattedMessage defaultMessage="Title French" />
                    </FormLabel>
                  </Grid>
                  <Grid item mb={1}>
                    <TextField
                      name="nameFrench"
                      placeholder={intl.formatMessage({ defaultMessage: 'Enter title in french' })}
                      value={nameFrench}
                      required
                      onChange={(e) => {
                        if (e.target.value !== '') {
                          // setNameError('');
                          setFormError((prev) => ({
                            ...prev,
                            nameFrenchError: ''
                          }));
                        }
                        setNameFrench(e.target.value);
                      }}
                      fullWidth
                    />
                  </Grid>
                </Grid>
                {formError.nameFrenchError ? <Typography color="red">{formError.nameFrenchError}</Typography> : null}
              </Grid>
              <Grid item>
                <Grid container direction="column" gap={1}>
                  <Grid item>
                    <Typography sx={{ fontWeight: 'bold' }}> {<FormattedMessage defaultMessage="Description" />}</Typography>
                  </Grid>
                  <Grid item mb={1}>
                    <TextField
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      name="description"
                      placeholder={intl.formatMessage({ defaultMessage: 'Enter description' })}
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <Grid container direction="column" gap={1}>
                  <Grid item>
                    <Typography sx={{ fontWeight: 'bold' }}> {<FormattedMessage defaultMessage="Description French" />}</Typography>
                  </Grid>
                  <Grid item mb={1}>
                    <TextField
                      value={descriptionFrench}
                      onChange={(e) => setDescriptionFrench(e.target.value)}
                      name="descriptionFrench"
                      placeholder={intl.formatMessage({ defaultMessage: 'Enter description in french' })}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {isFromTemplate ? (
              <Grid item>
                <Grid container direction="column" gap={1}>
                  <Grid item>
                    <FormLabel sx={{ color: '#565656', fontWeight: 800 }}>
                      {<FormattedMessage defaultMessage="Usable in Notes" />}
                    </FormLabel>
                  </Grid>
                  <Grid item mb={1}>
                    <RadioGroup name="isForNotes" row onChange={(e) => setIsForNotes(e.target.value === 'true')}>
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        checked={isForNotes}
                        label={<FormattedMessage defaultMessage="Yes" />}
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio />}
                        checked={!isForNotes}
                        label={<FormattedMessage defaultMessage="No" />}
                      />
                    </RadioGroup>
                  </Grid>
                </Grid>
              </Grid>
            ) : null}
            <Grid item>
              <Grid container direction="column" gap={1}>
                <Grid item>
                  <FormLabel required sx={{ color: '#565656', fontWeight: 800 }}>
                    {' '}
                    {<FormattedMessage defaultMessage="Select From Type" />}
                  </FormLabel>
                </Grid>
                <Grid item>
                  <Stack>
                    <Box display="flex" gap={2}>
                      <Stack
                        onClick={() => {
                          setFormType((prev) => {
                            if (prev !== 'default') {
                              setSelectedTemplate('');
                            }
                            return prev !== 'default' ? 'default' : undefined;
                          });
                          if (!formType) {
                            // setFormTypError('');
                            setFormError((prev) => ({
                              ...prev,
                              formTypeError: ''
                            }));
                          }
                        }}
                        sx={{ cursor: 'pointer' }}
                      >
                        <img
                          src={defaultFormImg}
                          alt="default-form"
                          style={{
                            border: formType === 'default' ? '1.5px solid #0076A1' : 'none',
                            borderRadius: formType === 'default' ? '12px' : 0
                          }}
                        />
                        <Box sx={{ alignSelf: 'center' }}>
                          <Typography sx={{ fontWeight: 'bold', color: formType === 'default' ? '#0076A1' : '#565656' }}>
                            <FormattedMessage defaultMessage="Default" />
                          </Typography>
                        </Box>
                      </Stack>
                      <Stack
                        onClick={() => {
                          setFormType((prev) => {
                            if (prev !== 'stepper') {
                              setSelectedTemplate('');
                            }
                            return prev !== 'stepper' ? 'stepper' : undefined;
                          });
                          if (!formType) {
                            // setFormTypError('');
                            setFormError((prev) => ({
                              ...prev,
                              formTypeError: ''
                            }));
                          }
                        }}
                        sx={{ cursor: 'pointer' }}
                      >
                        <img
                          src={stepperFormImg}
                          alt="stepper-form"
                          style={{
                            border: formType === 'stepper' ? '1.5px solid #0076A1' : 'none',
                            borderRadius: formType === 'stepper' ? '12px' : 0
                          }}
                        />
                        <Box sx={{ alignSelf: 'center' }}>
                          <Typography sx={{ fontWeight: 'bold', color: formType === 'stepper' ? '#0076A1' : '#565656' }}>
                            <FormattedMessage defaultMessage="Wizard" />
                          </Typography>
                        </Box>
                      </Stack>
                    </Box>
                    {formError.formTypeError ? <Typography color="red">{formError.formTypeError}</Typography> : null}
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              {!isFromTemplate ? (
                // && !isClinicDocuments
                <Grid container direction="column" gap={1}>
                  <Grid item>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      <FormattedMessage defaultMessage="Template" />
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Select
                      id="demo-simple-select"
                      value={selectedTemplate}
                      onChange={(e) => {
                        setSelectedTemplate(e.target.value);
                      }}
                      fullWidth
                      displayEmpty
                      disabled={Boolean(formBuilder?.name)}
                      placeholder={(<FormattedMessage defaultMessage="Select Template" />) as unknown as string}
                    >
                      <MenuItem value="" key="-1">
                        {(<FormattedMessage defaultMessage="Select Template" />) as unknown as string}
                      </MenuItem>
                      {templates?.map((template) => {
                        if (
                          template.type === formType &&
                          template.status &&
                          !template.archive &&
                          template?.templateAvailableTo[roleToRoleEnum.get((user as User).role) as string]
                        ) {
                          return (
                            <MenuItem value={template._id} key={template._id}>
                              {template.name} ({template.type === 'stepper' ? 'Wizard' : 'Default'})
                            </MenuItem>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </Select>
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container p={2} pt={0} gap={1}>
            <Grid item xs={5.9}>
              <Button
                onClick={onCancel}
                variant="outlined"
                color="secondary"
                fullWidth
                sx={{
                  borderRadius: '8px'
                }}
              >
                <FormattedMessage defaultMessage="Cancel" />
              </Button>
            </Grid>
            <Grid item xs={5.9}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{
                  borderRadius: '8px'
                }}
              >
                {formBuilder?.name ? <FormattedMessage defaultMessage="Edit" /> : <FormattedMessage defaultMessage="Create" />}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </FormContainer>
    </Dialog>
    // </FormLocales>
  );
};

export default CreateForm;
